import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { useDispatch } from 'react-redux';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';

const changeEndDate = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/end_date/${shutdownId}`,
    data,
    'Не удалось сохранить дату окончания',
    'Error'
  );

  return res;
};

export const useShutdownEndDateChange = (options = {}) => {
  const dispatch = useDispatch();

  const changeMutation = useMutation(changeEndDate, {
    ...options,
    onSuccess: (res, { shutdownId, data }) => {
      if (res !== 'Error') {
        dispatch(fetchShutdownsThunk());
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
